/**
 * ============================================
 * APPLICATION ENTRY POINT
 * ============================================
 * 
 * Main entry file for the React application.
 * Initializes React and registers the service worker.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// ============================================
// Register Service Worker for PWA
// ============================================
import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    // Show a prompt to the user to refresh for new content
    if (confirm('New content available. Reload?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

// ============================================
// Render Application
// ============================================
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
